import { GET_AGENTS, GET_DEPARTAMENT } from './mutation-types'

export default {
  [GET_DEPARTAMENT]: (state, departament) =>{
    state.departament = departament
  },

  [GET_AGENTS]: (state, agents) => {
    state.agents = agents
  },
}
